import { lazy } from 'react';

import { LayoutType, PageType } from '@shared/constants/constants';
import {
  ACTION_BACK_PATH,
  NEHR_ACCESS_RESTRICTION_DECLARATION_PATH,
  NEHR_ACCESS_RESTRICTION_INFO_PATH,
  NEHR_ACCESS_RESTRICTION_MODIFY_PATH,
  NEHR_ACCESS_RESTRICTION_PATH,
  NEHR_ACCESS_RESTRICTION_SEARCH_PATH,
  NEHR_ACCESS_RESTRICTION_SUBMITTED_PATH,
  NEHR_ACCESS_RESTRICTION_VIDEO_PATH,
} from '@shared/constants/paths';
import { SERVICE_CATALOG_CODE } from '@shared/constants/serviceCatalog';
import type { RouteConfig } from '@shared/types/common.types';

const NehrAccessRestrictionStatusPage = lazy(
  () => import('./pages/NehrAccessRestrictionStatusPage/NehrAccessRestrictionStatusPage')
);

const NehrAccessRestrictionVideoPage = lazy(
  () => import('./pages/NehrAccessRestrictionVideoPage/NehrAccessRestrictionVideoPage')
);

const NehrAccessRestrictionDeclarationPage = lazy(
  () => import('./pages/NehrAccessRestrictionDeclarationPage/NehrAccessRestrictionDeclarationPage')
);

const NehrAccessRestrictionInfoPage = lazy(
  () => import('./pages/NehrAccessRestrictionInfoPage/NehrAccessRestrictionInfoPage')
);

const NehrAccessRestrictionModifyPage = lazy(
  () => import('./pages/NehrAccessRestrictionModifyPage/NehrAccessRestrictionModifyPage')
);

const NehrAccessRestrictionSearchPage = lazy(
  () => import('./pages/NehrAccessRestrictionSearchPage/NehrAccessRestrictionSearchPage')
);

const NehrAccessRestrictionSubmittedPage = lazy(
  () => import('./pages/NehrAccessRestrictionSubmittedPage/NehrAccessRestrictionSubmittedPage')
);

export const NEHR_ACCESS_RESTRICTION_ROUTES: RouteConfig[] = [
  {
    actionUrl: ACTION_BACK_PATH,
    availableViews: [LayoutType.MOBILE],
    component: () => <NehrAccessRestrictionStatusPage />,
    displayTitle: () => 'NEHR Access Restriction',
    pageType: PageType.PRIVATE,
    path: NEHR_ACCESS_RESTRICTION_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.nehrAccessRestriction,
  },
  {
    availableViews: [LayoutType.MOBILE],
    component: () => <NehrAccessRestrictionVideoPage />,
    displayTitle: () => 'NEHR Access Restriction',
    pageType: PageType.PRIVATE,
    path: NEHR_ACCESS_RESTRICTION_VIDEO_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.nehrAccessRestriction,
  },
  {
    availableViews: [LayoutType.MOBILE],
    component: () => <NehrAccessRestrictionDeclarationPage />,
    displayTitle: () => 'NEHR Access Restriction',
    pageType: PageType.PRIVATE,
    path: NEHR_ACCESS_RESTRICTION_DECLARATION_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.nehrAccessRestriction,
  },
  {
    availableViews: [LayoutType.MOBILE],
    component: () => <NehrAccessRestrictionInfoPage />,
    displayTitle: () => 'NEHR Access Restriction',
    pageType: PageType.PRIVATE,
    path: NEHR_ACCESS_RESTRICTION_INFO_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.nehrAccessRestriction,
  },
  {
    availableViews: [LayoutType.MOBILE],
    component: () => <NehrAccessRestrictionModifyPage />,
    displayTitle: () => 'NEHR Access Restriction',
    pageType: PageType.PRIVATE,
    path: NEHR_ACCESS_RESTRICTION_MODIFY_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.nehrAccessRestriction,
  },
  {
    availableViews: [LayoutType.MOBILE],
    component: () => <NehrAccessRestrictionSearchPage />,
    displayTitle: () => 'Add Care Provider',
    pageType: PageType.PRIVATE,
    path: NEHR_ACCESS_RESTRICTION_SEARCH_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.nehrAccessRestriction,
  },
  {
    availableViews: [LayoutType.MOBILE],
    component: () => <NehrAccessRestrictionSubmittedPage />,
    displayTitle: () => 'NEHR Access Restriction',
    pageType: PageType.PRIVATE,
    path: NEHR_ACCESS_RESTRICTION_SUBMITTED_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.nehrAccessRestriction,
  },
];
